import { ReactNode } from "react";
import Header from "./header";
import Footer from "./footer";

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <noscript>
        <div id="no-script">
          <div id="no-script-box">
            <img id="no-script-img" src="/images/js_logo.png" alt="JS Logo" />
            <p id="no-script-maintext">
              Oh No! JavaScript is needed to run this app.
            </p>
            <p id="no-script-subtext">
              Please enable JavaScript in your browser settings and reload the
              page. For more info visit&nbsp;
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.enable-javascript.com/"
              >
                https://www.enable-javascript.com
              </a>
              <br />
              Thank You!
            </p>
          </div>
        </div>
      </noscript>

      <div id="main-content">
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
    </>
  );
}
